import { APIConfiguration } from '@savgroup-front-common/configuration';
import {
  COMMON_QUERY_PARAMS,
  SUPPORTED_METHODS,
} from '@savgroup-front-common/constants/shared';
import {
  BackResponse,
  BackResponseFailure,
  Store,
} from '@savgroup-front-common/types';

import { prepareResponseFailure } from '../../helpers';
import { ApiRequestDescriptor, executeQuery } from '../../services';

const ENDPOINT = `${APIConfiguration.actor}sellers/${COMMON_QUERY_PARAMS.SELLER_ID}/stores`;

export interface GetStoresBySellerIdQueryArgs {
  sellerId: string;
}

export const getStoresBySellerIdRequest = ({
  sellerId,
}: GetStoresBySellerIdQueryArgs): ApiRequestDescriptor => ({
  url: ENDPOINT.replace(COMMON_QUERY_PARAMS.SELLER_ID, sellerId),
  config: { method: SUPPORTED_METHODS.GET },
});

export const getStoresBySellerIdQuery = async (
  payload: GetStoresBySellerIdQueryArgs,
): Promise<BackResponse<Store[]> | BackResponseFailure> => {
  try {
    return await executeQuery<BackResponse<Store[]>>(
      getStoresBySellerIdRequest(payload),
    );
  } catch (error) {
    return prepareResponseFailure(error);
  }
};
